import React from "react";
import { useLocation } from "react-router-dom";
import { PAGE_DESCRIPTIONS, findMenuContext } from "../../constants/menuConstants";
import { PageHeader } from "../../ui/Layout";

/**
 * PageHeader for portal screens. Title defaults to the menu label for this route,
 * and the one-line description comes from PAGE_DESCRIPTIONS unless you pass one.
 */
const ScreenHeader = ({ title, description, ...rest }) => {
  const { pathname } = useLocation();
  const ctx = findMenuContext(pathname);
  const exact = PAGE_DESCRIPTIONS[pathname];
  return (
    <PageHeader
      title={title ?? ctx?.item?.label ?? "ChipMonk"}
      description={description === undefined ? exact : description}
      {...rest}
    />
  );
};

export default ScreenHeader;
